import { getStatusColor } from "@/lib/colors";

export function formatDuration(seconds) {
  if (!seconds || seconds <= 0) return "0h 0m";
  const totalMinutes = Math.round(seconds / 60);
  const h = Math.floor(totalMinutes / 60);
  const m = totalMinutes % 60;
  return `${h}h ${m}m`;
}

export function parseDurationToSeconds(input) {
  // Accepts: "1h 30m", "90m", "2h", "1.5h", "45"
  if (!input) return 0;
  const s = String(input).trim().toLowerCase();
  if (!s) return 0;
  let total = 0;
  let matched = false;
  const hMatch = s.match(/(\d+(?:\.\d+)?)\s*h/);
  const mMatch = s.match(/(\d+(?:\.\d+)?)\s*m/);
  if (hMatch) { total += parseFloat(hMatch[1]) * 3600; matched = true; }
  if (mMatch) { total += parseFloat(mMatch[1]) * 60; matched = true; }
  if (!matched) {
    // plain number => minutes
    const n = parseFloat(s);
    if (!isNaN(n)) total = n * 60;
  }
  return Math.round(total);
}

export function statusBgClasses(color) {
  const c = getStatusColor(color);
  return `${c.bg} ${c.text} ${c.border}`;
}

export function statusPillClasses(color) {
  // Solid colorful pill, like ClickUp
  return getStatusColor(color).pill;
}

export function statusDotClasses(color) {
  return getStatusColor(color).dot;
}

export function priorityClasses(p) {
  switch (p) {
    case "urgent": return "text-red-700 bg-red-50 border-red-200";
    case "high": return "text-orange-700 bg-orange-50 border-orange-200";
    case "medium": return "text-blue-700 bg-blue-50 border-blue-200";
    default: return "text-neutral-600 bg-neutral-50 border-neutral-200";
  }
}

export function formatDate(iso) {
  if (!iso) return "";
  try {
    const d = new Date(iso);
    return d.toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
  } catch {
    return "";
  }
}

export function initials(name) {
  if (!name) return "?";
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}
